<script>
import { mapGetters } from 'vuex';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import emptyInboxSvg from 'dashboard/assets/images/smarticks/empty-inbox.svg';

export default {
  components: {
    Spinner,
  },
  props: {
    emptyStateMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return { emptyInboxSvg };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'notifications/getUIFlags',
      isRTL: 'accounts/isRTL',
    }),
    title() {
      if (this.emptyStateMessage) return this.emptyStateMessage;
      return this.$t('INBOX.LIST.EMPTY_STATE_TITLE');
    },
    subtitle() {
      return this.$t('INBOX.LIST.EMPTY_STATE_SUBTITLE');
    },
  },
};
</script>

<template>
  <div
    class="items-center justify-center hidden w-full h-full text-center bg-n-surface-1 lg:flex"
  >
    <div v-if="uiFlags.isFetching" class="flex justify-center my-4">
      <Spinner class="text-n-brand" />
    </div>
    <div v-else class="flex flex-col items-center gap-4 max-w-md px-6">
      <img
        :src="emptyInboxSvg"
        class="w-72 h-auto"
        :class="[{ 'rtl-flip': isRTL }]"
        alt=""
      />
      <h2 dir="auto" class="text-base font-semibold text-n-slate-12">
        {{ title }}
      </h2>
      <p dir="auto" class="text-sm text-n-slate-11">{{ subtitle }}</p>
    </div>
  </div>
</template>

<style scoped>
.rtl-flip {
  transform: scaleX(-1);
}
</style>
